import Konva from 'konva';
import { v4 as uuidv4 } from 'uuid';

import HaspObject from './HaspObject';

// val	byte	0	The brightness of the indicator [0..255]

export default class HaspLed extends HaspObject {

    constructor(config) {
        config.height ??= 40;
        config.width ??= 40;
        config.entity_id ??= ''; //make sure this object can set its entityid
        super(config);
        this.haspid = config.haspid;
        this.minWidth = 20;
        this.minHeight = 20;

        this.on('data_val', (e) => {
            //intensity is based on its val
            let intensityScale = this.val / 255;
            // Convert color to RGB components
            let color = Konva.Util.colorToRGBA(this.style('main').bg_color);
            let { r, g, b } = color;
            // Adjust color intensity
            let adjustedR = Math.round(r * intensityScale);
            let adjustedG = Math.round(g * intensityScale);
            let adjustedB = Math.round(b * intensityScale);
            // create the adjusted color
            let adjustedColor = `rgb(${adjustedR},${adjustedG},${adjustedB})`;
            // Set the adjusted color
            this.rect.fill(adjustedColor);
        });

        this.onStyle('main', 'border_color', () => {
            //mix the border_color with the bg_color and set it for the border
            const main = this.style('main');
            let rgb1 = Konva.Util.colorToRGBA(main.bg_color);
            let rgb2 = Konva.Util.colorToRGBA(main.border_color);

            // Calculate average RGB components
            let mixedR = Math.round((rgb1.r + rgb2.r) / 2);
            let mixedG = Math.round((rgb1.g + rgb2.g) / 2);
            let mixedB = Math.round((rgb1.b + rgb2.b) / 2);

            // Convert mixed RGB components to hex color
            let mixedColor = `rgb(${mixedR}, ${mixedG}, ${mixedB})`;
            this.rect.stroke(mixedColor);
        });
    }

}